import { jsx as _jsx } from "react/jsx-runtime";
import { ENABLE_CONSUMER_MODE } from "@faire/retailer/lib/consts";
import { AmexIncentiveBanner } from "@faire/retailer/components/Notifications/AmexIncentiveBanner";
import { BrandPreviewBanner } from "@faire/retailer/components/Notifications/BrandPreviewBanner";
import { BrandsCountBanner } from "@faire/retailer/components/Notifications/BrandsCountBanner";
import { ConsumerModeBanner } from "@faire/retailer/components/Notifications/Components/ConsumerModeBanner/ConsumerModeBanner";
import { FaireDirectIncentivesBanner } from "@faire/retailer/components/Notifications/Components/FaireDirectIncentivesBanner/FaireDirectIncentivesBanner";
import { FirstOrderIncentiveBanner } from "@faire/retailer/components/Notifications/Components/FirstOrderIncentiveBanner/FirstOrderIncentiveBanner";
import { InsiderAutoEnrollBanner } from "@faire/retailer/components/Notifications/Components/InsiderAutoEnrollBanner/InsiderAutoEnrollBanner";
import { MarketCountdownBanner } from "@faire/retailer/components/Notifications/Components/MarketCountdownBanner/MarketCountdownBanner";
import { OpeningOrderIncentivesBanner } from "@faire/retailer/components/Notifications/Components/OpeningOrderIncentivesBanner/OpeningOrderIncentivesBanner";
import { ReferralFollowupBanner } from "@faire/retailer/components/Notifications/Components/ReferralFollowupBanner";
import { FaireValuesBanner } from "@faire/retailer/components/Notifications/FaireValuesBanner";
import { EmployeeGrantedFreeFreightBanner } from "@faire/retailer/components/Notifications/FreeFreightBanners";
import { OpenWithFaireEligibleToApplyBanner } from "@faire/retailer/components/Notifications/OpenWithFaireEligibleToApplyBanner";
import { PosIntegrationBanner } from "@faire/retailer/components/Notifications/PosIntegrationBanner";
import { SpecialHolidayNet90PromoBanner } from "@faire/retailer/components/Notifications/SpecialHolidayNet90PromoBanner";
import { WarehouseSaleBanner } from "@faire/retailer/components/Notifications/WarehouseSaleBanner";
import { PromoBannerType } from "@faire/retailer-visitor-shared/components/Notifications/PromoBanner/bannerOrder";
import { ConductorBanner } from "@faire/retailer/components/Notifications/PromoBanner/ConductorBanner";
import { UnlockBanner, LowMinimumsBanner, FreeReturnsBanner, BuyNowPay60DaysBanner } from "@faire/retailer/components/Notifications/GlobalBannerXp";
import { Storage } from "@faire/web--source/common/Storage";
import React from "react";
export var getPromoBanner = function(type) {
    var globalXpBanner = getGlobalXpBanner(type);
    var isConsumerMode = Storage.session.getItem(ENABLE_CONSUMER_MODE);
    if (globalXpBanner && !isConsumerMode) {
        return globalXpBanner;
    }
    switch(type){
        case PromoBannerType.FAIRE_DIRECT_INCENTIVES:
            return /*#__PURE__*/ _jsx(FaireDirectIncentivesBanner, {});
        case PromoBannerType.MARKET_COUNTDOWN:
            return /*#__PURE__*/ _jsx(MarketCountdownBanner, {});
        case PromoBannerType.CONDUCTOR_BANNERS:
            return /*#__PURE__*/ _jsx(ConductorBanner, {});
        case PromoBannerType.FAIRE_VALUES:
            return /*#__PURE__*/ _jsx(FaireValuesBanner, {});
        case PromoBannerType.FIRST_ORDER_INCENTIVE:
            return /*#__PURE__*/ _jsx(FirstOrderIncentiveBanner, {});
        case PromoBannerType.INSIDER_AUTO_ENROLL:
            return /*#__PURE__*/ _jsx(InsiderAutoEnrollBanner, {});
        case PromoBannerType.SPECIAL_HOLIDAY_NET90:
            return /*#__PURE__*/ _jsx(SpecialHolidayNet90PromoBanner, {});
        case PromoBannerType.OPENING_ORDER_INCENTIVES:
            return /*#__PURE__*/ _jsx(OpeningOrderIncentivesBanner, {});
        case PromoBannerType.AMEX_INCENTIVE:
            return /*#__PURE__*/ _jsx(AmexIncentiveBanner, {});
        case PromoBannerType.BRAND_PREVIEW:
            return /*#__PURE__*/ _jsx(BrandPreviewBanner, {});
        case PromoBannerType.BRANDS_COUNTER:
            return /*#__PURE__*/ _jsx(BrandsCountBanner, {});
        case PromoBannerType.WAREHOUSE_SALE:
            return /*#__PURE__*/ _jsx(WarehouseSaleBanner, {});
        case PromoBannerType.EMPLOYEE_GRANTED_FREE_FREIGHT:
            return /*#__PURE__*/ _jsx(EmployeeGrantedFreeFreightBanner, {});
        case PromoBannerType.OPEN_WITH_FAIRE:
            return /*#__PURE__*/ _jsx(OpenWithFaireEligibleToApplyBanner, {});
        case PromoBannerType.POS_INTEGRATION:
            return /*#__PURE__*/ _jsx(PosIntegrationBanner, {});
        case PromoBannerType.REFERRAL_FOLLOWUP:
            return /*#__PURE__*/ _jsx(ReferralFollowupBanner, {});
        case PromoBannerType.CONSUMER_MODE:
            return /*#__PURE__*/ _jsx(ConsumerModeBanner, {});
        default:
            return null;
    }
};
var getGlobalXpBanner = function(type) {
    switch(type){
        case PromoBannerType.UNLOCK:
            return /*#__PURE__*/ _jsx(UnlockBanner, {});
        case PromoBannerType.LOW_MINIMUMS:
            return /*#__PURE__*/ _jsx(LowMinimumsBanner, {});
        case PromoBannerType.FREE_RETURNS:
            return /*#__PURE__*/ _jsx(FreeReturnsBanner, {});
        case PromoBannerType.BUY_NOW_PAY_60_DAYS:
            return /*#__PURE__*/ _jsx(BuyNowPay60DaysBanner, {});
        default:
            return null;
    }
};
